export enum RouteOptions {
  LESS_WALKING = 'LESS_WALKING',
  LOW_FLOOR = 'LOW_FLOOR',
  FEWER_TRANSFERS = 'FEWER_TRANSFERS',
  BEST_ROUTE = 'BEST_ROUTE'
}

export type Languages = 'en' | 'uk';
